import React from 'react';

const WeddingTailoring = () => {
  const bannerSlides = [
    '/images/wedding-banner.webp',
    '/images/wedding-banner-1.webp',
    '/images/wedding-banner-2.webp',
  ];
  const [activeBanner, setActiveBanner] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setActiveBanner((i) => (i + 1) % bannerSlides.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [bannerSlides.length]);

  const collections = [
    { title: 'A Statement in Scarlet', detail: 'The High-Neck Shawl Collar Tuxedo. Tailored to command attention.', img: '/images/wedding-1.webp' },
    { title: 'Couple Eveningwear', detail: 'Elegant black tuxedo and lace gown ensemble crafted for a memorable first dance moment.', img: '/images/wedding-2.webp' },
    { title: 'Elegant Occasion Suiting', detail: 'Classic dark suit paired with a silk tie, styled for the ceremony and complementing bridal red.', img: '/images/wedding-3.webp' },
    { title: 'Built for the Best Men', detail: 'Navy three-piece suit with boutonniere, coordinated alongside bridal party for a polished wedding portrait.', img: '/images/wedding-4.webp', objPos: 'object-top' },
    { title: 'Reception Tuxedo', detail: 'Sleek black tuxedo with bow tie, styled for evening receptions and cocktail celebrations.', img: '/images/wedding-5.webp' },
    { title: 'Celebration Wear', detail: 'Custom black jacquard tuxedo designed for the groom\'s post-wedding celebrations and festivities.', img: '/images/wedding-6.webp' },
  ];

  return (
    <>
      {/* Mobile banner */}
      <div className="block lg:hidden relative w-full overflow-hidden">
        {bannerSlides.map((src, index) => (
          <img key={src} src={src} alt="Wedding Tailoring" className={`${index === 0 ? 'relative' : 'absolute inset-0'} w-full h-auto object-contain transition-opacity duration-500 ${index === activeBanner ? 'opacity-100' : 'opacity-0'}`} />
        ))}
      </div>
      <div className="block lg:hidden px-6 py-6 bg-background-light dark:bg-background-dark">
        <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-4 block">Bespoke Wedding Tailoring</span>
        <h1 className="font-display text-4xl leading-[0.95] mb-4 dark:text-white">Wedding<br />Tailoring</h1>
        <div className="w-10 h-px bg-primary mb-4" />
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">Sophisticated cuts and custom craftsmanship designed around your rhythm and style.</p>
      </div>
      {/* Desktop banner */}
      <header className="hidden lg:block relative w-full lg:h-[70vh] overflow-hidden bg-background-light dark:bg-background-dark">
        <div className="relative z-10 flex flex-col justify-center w-full lg:w-[28%] lg:h-full px-6 sm:px-8 md:px-12 lg:px-16 py-8 lg:py-0 flex-shrink-0">
          <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-6">Bespoke Wedding Tailoring</span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] mb-6 dark:text-white">Wedding<br />Tailoring</h1>
          <div className="w-10 h-px bg-primary mb-6" />
          <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xs leading-relaxed">Sophisticated cuts and custom craftsmanship designed around your rhythm and style.</p>
        </div>
        <div className="absolute inset-y-0 right-0 w-[80%] h-full">
          {bannerSlides.map((src, index) => (
            <img key={src} src={src} alt="Wedding Tailoring" className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-500 ${index === activeBanner ? 'opacity-100' : 'opacity-0'}`} />
          ))}
          <div className="absolute inset-y-0 left-0 w-[15%] bg-gradient-to-r from-background-light dark:from-background-dark to-transparent" />
        </div>
      </header>

      <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2 className="font-display text-3xl md:text-4xl mb-6">Designed for Presence, Built for Comfort</h2>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            Every wedding ensemble is crafted through personal consultation, precise measurement, and staged fittings — ensuring you look and feel exceptional on your most important day.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {collections.map((item) => (
            <div key={item.title} className="rounded-2xl overflow-hidden shadow-md bg-white dark:bg-surface-dark group">
              <div className="relative w-full overflow-hidden" style={{paddingBottom: '133%', height: 0}}>
                <img src={item.img} alt={item.title} className={`absolute inset-0 w-full h-full object-cover ${item.objPos || 'object-center'} transition-transform duration-500 group-hover:scale-105`} />
                <div className="hidden md:block absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="hidden md:block absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-display text-xl text-white mb-1">{item.title}</h3>
                  <p className="text-white/70 text-xs leading-relaxed">{item.detail}</p>
                </div>
              </div>
              <div className="block md:hidden px-3 py-2">
                <h3 className="font-display text-sm leading-tight mb-1 dark:text-white">{item.title}</h3>
                <p className="text-gray-500 dark:text-gray-400 text-xs leading-relaxed">{item.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default WeddingTailoring;
